import { map } from "lodash";
import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { SubBar, MainView, Menu } from "lib/index";
import IframeWidgetView from "./IframeWidgetView";
import BubbleWidgetView from "./BubbleWidgetView";
import ButtonWidgetView from "./ButtonWidgetView";
import IndexWidgetView from "./IndexWidgetView";
import { stateSelector, initializeView } from "./index";

const WIDGETS_DATA = [
  {
    type: "Widgety",
    label: () => I18n.t("papp.settings.WidgetsSettingsView.title"),
    WidgetView: IndexWidgetView,
  },
  {
    type: "Iframe",
    label: () => I18n.t("papp.settings.WidgetsSettingsView.iframe"),
    WidgetView: IframeWidgetView,
  },
  {
    type: "Bubble",
    label: () => I18n.t("papp.settings.WidgetsSettingsView.bubble"),
    WidgetView: BubbleWidgetView,
  },
  {
    type: "Button",
    label: () => I18n.t("papp.settings.WidgetsSettingsView.button"),
    WidgetView: ButtonWidgetView,
  },
  // {
  //   type: "NavBar",
  //   label: () => I18n.t("papp.settings.WidgetsSettingsView.navbar"),
  //   WidgetView: NavBarWidgetView
  // }
];

@connect(
  (state) => ({
    currentCompany: state.auth.company.model,
    products: stateSelector(state).products,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        initializeView,
      },
      dispatch
    )
)
export default class WidgetsSettingsView extends React.Component {
  state = {
    currentWidgetType: WIDGETS_DATA[0].type,
  };

  componentDidMount() {
    this.props.initializeView();
  }

  render() {
    const { currentCompany, products } = this.props;
    const { currentWidgetType } = this.state;
    const currentWidgetData = WIDGETS_DATA.find((w) => w.type === currentWidgetType);
    const marketplace = currentCompany.is_st || currentCompany.affiliate ? true : false;

    return (
      <MainView.Container>
        <SubBar hasSidebar>
          <h1>{I18n.t("papp.settings.WidgetsSettingsView.title")}</h1>
        </SubBar>

        <MainView.Content hasSubBar>
          <Menu secondary pointing color="teal" className="u-marginBottom">
            {WIDGETS_DATA.map((widgetData) => (
              <Menu.Item
                key={widgetData.type}
                active={currentWidgetType === widgetData.type}
                onClick={() => this.setState({ currentWidgetType: widgetData.type })}
                content={widgetData.label()}
              />
            ))}
          </Menu>

          <currentWidgetData.WidgetView company={currentCompany} products={products} marketplace={marketplace} />
        </MainView.Content>
      </MainView.Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/settings/WidgetsSettingsView/WidgetsSettingsView.jsx